module.exports = __webpack_public_path__ + "static/media/22.4833ea6d.jpg";